/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Properties_Bulk_SelectedInputs */

const cs_properties_bulk_selected = /** @type {(inputs: Properties_Bulk_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vybráno ${i?.count}`)
};

const en_properties_bulk_selected = /** @type {(inputs: Properties_Bulk_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Properties_Bulk_SelectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_bulk_selected = /** @type {((inputs: Properties_Bulk_SelectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_Bulk_SelectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_bulk_selected(inputs)
	return cs_properties_bulk_selected(inputs)
});